import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Skeleton } from 'primereact/skeleton'
import { useTranslation } from 'react-i18next'

const ItemsListCollapseableTable = ({
  data,
  columns,
  rowExpansionTemplate,
  expensionHeaderClass,
  dataKey,
  emptyMessage = 'No Results Found.',
  loading = false,
  rowClassName,
  expandedRows: controlledExpandedRows,
  onRowToggle: controlledOnRowToggle,
  expandAllRows = false,
  hideExpander = false,
  expansionBodyClassName = '',
  expandedRowClassName = '!bg-gray-100'
}) => {
  const [internalExpandedRows, setInternalExpandedRows] = useState({})
  const { t, i18n } = useTranslation()
  const expandedRows = expandAllRows
    ? data?.reduce((acc, row) => {
        const key = dataKey ? row?.[dataKey] : row
        if (key) acc[key] = true
        return acc
      }, {})
    : controlledExpandedRows !== undefined ? controlledExpandedRows : internalExpandedRows
  const onRowToggle = controlledOnRowToggle || (e => setInternalExpandedRows(e.data))

  return (
    <div className='relative'>
      <DataTable
        value={loading ? Array(7).fill({}) : data}
        expandedRows={expandedRows}
        onRowToggle={expandAllRows ? undefined : onRowToggle}
        rowExpansionTemplate={rowExpansionTemplate ? (e => rowExpansionTemplate(e, t)) : undefined}
        dataKey={dataKey}
        emptyMessage={t(emptyMessage)}
        rowClassName={rowClassName}
        pt={{
          rowExpansion: {
            className: expansionBodyClassName
          },
          bodyRow: ({ context }) => ({
            className: context.expanded ? expandedRowClassName : ''
          })
        }}
      >
        {rowExpansionTemplate && !hideExpander && (
          <Column
            expander
            style={{ width: '2em', padding: '6px' }}
            pt={{
              headerCell: {
                className: `!px-[0.35rem] !py-[0.6rem] bg-gray-200 ${i18n.language == 'en' ? '!text-left' : '!text-right'
                  } ${expensionHeaderClass} `
              }
            }}
          />
        )}
        {columns.map((col, index) => (
          <Column
            key={index}
            field={col.field}
            header={col.header}
            body={loading ? () => <Skeleton width='100%' height='1.5rem' /> : col?.body}
            pt={{
              headerCell: {
                className: `!px-[0.35rem] !py-[0.6rem] bg-gray-300 ${i18n.language == 'en' ? '!text-left' : '!text-right'
                  } ${col.headerCellClass || ''}`,
                ...col.pt?.headerCell
              },
              headerTitle: {
                className: 'text-14-dark !font-[600] whitespace-nowrap'
              },
              bodyCell: {
                className: `!px-[0.35rem] !py-[0.6rem] text-12-gray leading-[1.25rem] border-b !border-b-gray-200 ${i18n.language == 'en' ? '!text-left' : '!text-right'
                  } whitespace-nowrap
                     ${col.bodyCellClass || ''} `,
                ...col.pt?.bodyCell
              },
              ...col.pt
            }}
          />
        ))}
      </DataTable>
    </div>
  )
}

export default ItemsListCollapseableTable
